export default {
  methods: {
    openEvent () {
      this.$emit('open')
    },
    openedEvent () {
      this.$emit('opened')
    },
    closeEvent () {
      this.$emit('close')
    },
    closedEvent () {
      this.$emit('closed')
    }
  }
}
